export default "__VITE_ASSET__DALbYyT5__"